import { SVGAttributes } from "react";

export function CommentIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6709 13.4206C17.2149 12.3624 17.4991 11.1898 17.5 9.99994C17.5 5.86475 14.1352 2.5 10 2.5C5.86477 2.5 2.5 5.86475 2.5 9.99994C2.5 14.1351 5.86477 17.4999 10 17.4999C11.1877 17.4999 12.3645 17.2142 13.4214 16.6715L16.6532 17.4794C16.7673 17.5082 16.887 17.5068 17.0004 17.4753C17.1139 17.4439 17.2172 17.3835 17.3002 17.3001C17.3835 17.2168 17.4438 17.1134 17.4752 16.9999C17.5067 16.8864 17.5081 16.7667 17.4795 16.6524L16.6709 13.4206ZM15.2848 13.4956L15.8807 15.8806L13.4957 15.284C13.3271 15.2424 13.149 15.2662 12.9973 15.3508C12.0819 15.865 11.0499 16.1354 10 16.1363C6.61614 16.1363 3.86364 13.3831 3.86364 9.99994C3.86364 6.61679 6.61614 3.86363 10 3.86363C13.3839 3.86363 16.1364 6.61679 16.1364 9.99994C16.1354 11.0495 15.8652 12.0812 15.3516 12.9965C15.2661 13.1481 15.2422 13.3268 15.2848 13.4956Z"
        fill="#2D4452"
      />
    </svg>
  );
}
